import React from "react";

const DarkContext = React.createContext({
    dark: null,
    toggleDark: () => { },
})
export default DarkContext
